import { PrismicNextImage } from '@prismicio/next';
import { Content, isFilled } from '@prismicio/client';

import { Box } from '@preventx/oxygen';

type WithBackgroundGraphicProps = {
  content: Content.PageHeroHeadlineSliceWithBackgroundGraphicPrimary;
};

export const WithBackgroundGraphic = ({
  content,
}: WithBackgroundGraphicProps) => {
  const { graphic } = content;

  if (!isFilled.image(graphic)) {
    return null;
  }

  return (
    <Box component="aside" className="hero__graphic">
      <figure className="hero-mask">
        <PrismicNextImage field={graphic} height={450} width={800} />
      </figure>
    </Box>
  );
};
